export const buildCounselorStudentParentPayload = ({
  messageBody,
  dstId,
  email,
  sendToStudent = false,
  sendToParent = false,
  attachmentUrl,
  single = false,
}) => {
  const trimmedEmail = typeof email === "string" ? email.trim() : "";
  const payload = {
    message_body: messageBody,
  };

  if (trimmedEmail) {
    payload.email = trimmedEmail;
  } else {
    payload.dst_id = Array.isArray(dstId)
      ? dstId.filter(Boolean)
      : dstId != null
        ? [dstId]
        : [];
  }

  if (sendToStudent && sendToParent) {
    payload.event_type = "counselor_student";
    payload.parent_ack = true;
  } else if (sendToParent) {
    payload.event_type = "counselor_parent";
    payload.parent_ack = true;
  } else {
    payload.event_type = "counselor_student";
  }

  if (attachmentUrl) {
    payload.attachment_url = attachmentUrl;
  }

  if (single) {
    payload.single = true;
  }

  return payload;
};

export const hasCounselorStudentParentSelection = (sendToStudent, sendToParent) =>
  Boolean(sendToStudent || sendToParent);
